import { parseStringToParams } from '../../utils/object';

const GA_PARAMS_NAME = 'linkerParam';

/**
 * @deprecated
 * Retrieves Universal Analytics parameters from the first tracker found on the page.
 *
 * This function is deprecated because Universal Analytics is being phased out in favor of Google Analytics 4.
 *
 * @returns {Record<string, string>} - An object with key-value pairs parsed from the GA linker parameter.
 */
export const getUniversalParams = (): Record<string, string> => {
  const gaValue =
    window.ga && window.ga.getAll && window.ga.getAll()[0].get(GA_PARAMS_NAME)
      ? window.ga.getAll()[0].get(GA_PARAMS_NAME)
      : '';
  return parseStringToParams(gaValue, {
    paramsSeparator: '&',
    keyValueSeparator: '=',
  });
};
